import React, { Fragment } from 'react';
import { Affix, Skeleton } from 'antd';

import DriverOrders from './DriverOrders'; // Загрузка водителя
import ExcludedVehicles from './ExcludedVehicles';
// import NextOrder from './NextOrder';
// import EmployeeCalendar from './EmployeeCalendar';
import FormProgress from '../../containers/ProfileCard/FormProgress/FormProgress';

// import BtnDriverOrders from './buttons/BtnDriverOrders';
// import BtnEditEmployee from './buttons/BtnEditEmployee';
import BtnArchiveEmployee from './buttons/BtnArchiveEmployee';
import BtnDeclineInvitation from './buttons/BtnDeclineInvitation';
import BtnCloseEditing from './buttons/BtnCloseEditing';
import BtnFormSubmit from './buttons/BtnFormSubmit';

import FormsContent from '../../containers/ProfileCard/Forms/Forms';
// import OrderSummary from './OrderSummary';

import './ProfileCard.css';

const CardEmployeeForm = ({ ...props }) => {
  const {
    /* инфа просматриваемого профиля */
    isLoading,
    profileData,
    profileDataErr,
    profileId,
    userIsDriver,
    createEmployeeClearError,
    /* todo загрузка водителя */
    visibleDriverOrders,
    // handleClickDriverOrdersShow,
    handleClickDriverOrdersHide,
    /* todo Исключить ТС */
    visibleExcludedVehicles,
    handleClickExcludeVehicles,
    handleClickExcludeVehiclesHide,
    // handleClickExcludeVehiclesShow,
    /* Редактирование профиля */
    isEditable,
    userIsDriverInEditForm,
    // handleClickEditEmployee,
    handleClickCloseEditing,
    handleChangeUserRoleInEditForm,
    formProgress,
    updateProgress,
    handleClickUpdateProfileStatus,
    /* работа с формами */
    setForm,
    checkFormErrors,
    formSubmit,
    // formErrors,
    checkUserByPhoneNumber,
    changePhone,
    disabledSaveButton,
    activeProfile,
  } = props;

  // const checkPhone = profileId === 0 ? checkUserByPhoneNumber && checkUserByPhoneNumber.status : true;
  return (
    <div className="employees">
      <div className="basicForm">
        <div className="add-employee">
          <div className="add-employee__wrap">
            <ExcludedVehicles
              handleClickExcludeVehiclesHide={handleClickExcludeVehiclesHide}
              handleClickExcludeVehicles={handleClickExcludeVehicles}
              visible={visibleExcludedVehicles}
            />
            <DriverOrders
              handleCloseAutoOrder={handleClickDriverOrdersHide}
              visible={visibleDriverOrders}
            />
            <div className="add-employee__content">
              {isLoading ? (
                <Skeleton active />
              ) : (
                <FormsContent
                  name="profileCard"
                  data={profileData}
                  dataErr={profileDataErr}
                  profileId={profileId}
                  userIsDriver={userIsDriver}
                  userIsDriverInEditForm={userIsDriverInEditForm}
                  progress={formProgress}
                  handleChangeUserRole={handleChangeUserRoleInEditForm}
                  updateProgress={updateProgress}
                  isEditable={isEditable}
                  setForm={setForm}
                  checkFormErrors={checkFormErrors}
                  createEmployeeClearError={createEmployeeClearError}
                  checkUserByPhoneNumber={checkUserByPhoneNumber}
                  changePhone={changePhone}
                />
              )}
            </div>

            <div className="cart-employee__sidebar">
              <Affix
                offsetTop={18}
                target={() => document.getElementById('mainSheet')}
              >
                <Fragment>
                  {isEditable && (
                    <div>
                      <BtnFormSubmit
                        name="profileCard"
                        handleClick={formSubmit}
                        disabled={
                          profileId === 0 && !userIsDriverInEditForm
                            ? checkUserByPhoneNumber &&
                              checkUserByPhoneNumber.status !== 'isLoading'
                              ? disabledSaveButton
                              : true
                            : disabledSaveButton
                        }
                        isDriver={userIsDriverInEditForm}
                        profileId={profileId}
                      />

                      <div className="add-employee__progress">
                        <FormProgress progress={formProgress} />
                      </div>

                      <BtnCloseEditing handleClick={handleClickCloseEditing} />
                    </div>
                  )}

                  {!isEditable &&
                    profileData &&
                    profileData.profileStatusKey !== '' && (
                      <div>
                        {/* profileData.profileStatusKey === 'active' && (
                          <BtnEditEmployee
                            handleClick={handleClickEditEmployee}
                          />
                        )*/}
                        {/*{userIsDriver &&*/}
                        {/*  profileData.profileStatusKey === 'active' && (*/}
                        {/*    <Fragment>*/}
                        {/*      <BtnDriverOrders*/}
                        {/*        handleClick={handleClickDriverOrdersShow}*/}
                        {/*      />*/}
                        {/*      <NextOrder />*/}
                        {/*      <EmployeeCalendar />*/}
                        {/*    </Fragment>*/}
                        {/*  )}*/}

                        {/*{(profileData.profileStatusKey === 'active' ||*/}
                        {/*  profileData.profileStatusKey === 'archive') && (*/}
                        {/*  <div className="cart-employee__order-summary">*/}
                        {/*    <OrderSummary />*/}
                        {/*  </div>*/}
                        {/*)}*/}

                        {profileData.profileStatusKey === 'wait' && (
                          <BtnDeclineInvitation
                            handleClick={handleClickUpdateProfileStatus}
                          />
                        )}

                        {profileData.profileId !== activeProfile &&
                          (profileData.profileStatusKey === 'active' ||
                            profileData.profileStatusKey === 'archive') && (
                            <BtnArchiveEmployee
                              isArchive={
                                profileData.profileStatusKey === 'archive'
                              }
                              handleClick={handleClickUpdateProfileStatus}
                            />
                          )}
                      </div>
                    )}
                </Fragment>
              </Affix>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardEmployeeForm;
